module.exports = __webpack_public_path__ + "static/img/partner-itoa.0408295.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-itoa.png
// module id = MzyX
// module chunks = 34